import { render, staticRenderFns } from "./supplierBlock.vue?vue&type=template&id=f8626d8a&"
import script from "./supplierBlock.vue?vue&type=script&lang=js&"
export * from "./supplierBlock.vue?vue&type=script&lang=js&"
import style0 from "./supplierBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports